import { buildFacetDesignOverrideLite, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import {
  FDBodyText, FDDisplayText, FDHeadlineText, FDTitleText,
} from '@facet-wealth/design';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export default buildFacetDesignOverrideLite()
  .nameOverride('miniHeader', {
    _component: () => FDTitleText,
    _customProps: {
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => FDDisplayText,
    _customProps: {
      size: 'sm',
      color: 'textAttention',
    },
  }, overrideReadOnly)
  .nameOverride('rackPrice', {
    _component: () => Richtext,
    _customProps: {
      Component: FDHeadlineText,
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride(['primaryOfferTitle', 'benefitSectionTitle'], {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride(['andersTitle'], {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'md',
    },
  }, overrideReadOnly)
  .nameOverride(['andersDescription'], {
    _component: () => FDBodyText,
  }, overrideReadOnly);
